import { PROCESS } from "../mock";

export default function Process() {
  return (
    <section id="process" className="py-24 md:py-32 bg-black text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-6 reveal">
            <p className="text-xs tracking-[0.25em] uppercase text-neutral-400 mb-4">
              — How I Work
            </p>
            <h2 data-split="words" className="display text-[40px] md:text-[64px] leading-[1.02]">
              A simple 4-step process that just works.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 flex items-end reveal">
            <p className="text-neutral-300 text-[15px] leading-relaxed">
              No confusing calls, no endless revisions. Just a clear, honest
              path from your first email to a live website your customers love.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
          {PROCESS.map((p, i) => (
            <div
              key={p.step}
              className="relative rounded-[24px] p-7 border border-white/10 hover:border-[#FFE14D] hover:bg-white/[0.03] transition-colors duration-500 reveal"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="flex items-center justify-between mb-6">
                <span className="display text-5xl font-extrabold text-[#FFE14D]">
                  {p.step}
                </span>
                <span className="w-2 h-2 rounded-full bg-[#FFE14D]" />
              </div>
              <h3 className="display text-2xl mb-3">{p.title}</h3>
              <p className="text-sm text-neutral-400 leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
